module.exports = __webpack_public_path__ + "static/media/bolso (41).1142aad9.jpg";